import React from 'react';
import { processSteps } from '../mock';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const ProcessSection = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const titles = [t.freeConsultation || 'Бесплатная консультация', t.legalAnalysis || 'Финансовый анализ', t.actionPlan || 'План действий', t.implementationReturn || 'Реализация и возврат'];
  const descs = [t.freeConsultationDesc || processSteps[0].description, t.legalAnalysisDesc || processSteps[1].description, t.actionPlanDesc || processSteps[2].description, t.implementationReturnDesc || processSteps[3].description];

  return (
    <section id="process" className="process-section">
      <div className="section-container">
        <div className="section-header centered">
          <h2 className="section-title">{t.howWeWork}</h2>
          <p className="section-subtitle">{t.howWeWorkSubtitle || 'Простой и прозрачный процесс возврата средств'}</p>
        </div>

        <div className="process-cards-grid">
          {processSteps.map((step, index) => (
            <div key={index} className="process-card-item">
              <div className="process-card-image-wrap">
                <img src={step.image} alt={titles[index]} className="process-card-image" loading="lazy" />
                <div className="process-card-step-badge">{step.step}</div>
              </div>
              <div className="process-card-body">
                <h3 className="process-card-title">{titles[index]}</h3>
                <p className="process-card-desc">{descs[index]}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="process-cta">
          <button 
            className="btn-primary btn-large"
            onClick={() => {
              navigate('/form?source=pixel2');
            }}
          >
            {t.startReturn || 'Начать возврат средств'}
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
